export default __webpack_public_path__ + "static/media/ios-arrow-down.34720620.svg";